import type { TopupHistoryItem } from "@/types/topup/history";
import { formatCurrency } from "@/utils/formatCurrency";
import { safeFormatDateTime } from "@/utils/formatDate";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

type TopupHistoryCardProps = {
   topup: TopupHistoryItem;
};

export function DesktopTopupHistoryList({ topup }: TopupHistoryCardProps) {
  return (
    <Link to={`/topup-history/${topup.topUpNo}`}>
      <div className="grid grid-cols-12 items-center gap-4 whitespace-nowrap bg-card py-3">
        <div className="col-span-2 text-sm font-semibold text-heading">
          {topup.topUpNo}
        </div>

        {/** Uncomment after has E.Invoice */}
        <div className="col-span-2 flex items-center justify-center">
          <div className="w-fit capitalize rounded-lg bg-background px-2 py-1 text-xs font-medium text-primary">
            {topup.eInvoiceStatus ?? "-"}
          </div>
        </div>

        <div className="text-sm font-medium text-foreground">
          {formatCurrency(topup.totalPrice)}
        </div>

        <div className="col-span-2 text-sm font-medium text-foreground text-center">{topup.pax}</div>

        <div className="col-span-3 text-sm font-medium text-foreground">
           {safeFormatDateTime(topup.purchaseDateTime)}
        </div>

        <div className="col-span-1 flex items-center justify-end gap-1 text-sm font-medium text-primary">
          View
          <ChevronRight size={14} />
        </div>
      </div>
    </Link>
  );
}
